import { Set } from 'immutable';
export function foldHiddenFiltersValue(hfv) {
  return function (boolean, set) {
    if (typeof hfv === 'boolean') {
      return boolean(hfv);
    } else if (Set.isSet(hfv)) {
      return set(hfv);
    } else {
      throw new TypeError("foldHiddenFiltersValue is not comprehensive in HiddenFiltersValue: ".concat(JSON.stringify(hfv)));
    }
  };
}